import React from 'react';
import { API_BASE_URL } from '../../helpers/ApiSettings';

const ProductSalesTable = ({ productSales, onEdit, onDelete }) => {
  const LEGACY_CATEGORY_LABELS = {
    'soins': 'Soins',
    'hygiene': 'Hygiène',
    'alimentation': 'Alimentation',
    'jouets': 'Jouets',
    'vetements': 'Vêtements'
  };
  const getCategoryLabel = (productSale) => {
    if (productSale.sale_category?.name) return productSale.sale_category.name;
    if (productSale.category) return LEGACY_CATEGORY_LABELS[productSale.category] || productSale.category;
    return '-';
  };

  const formatPrice = (price) => {
    return price ? `${parseFloat(price).toFixed(2)}€` : '-';
  };

  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th>Image</th>
            <th>Titre</th>
            <th>Code EAN</th>
            <th>Prix unitaire</th>
            <th>Prix groupé</th>
            <th>Stock</th>
            <th>Catégorie</th>
            {/* <th>Marque</th> */}
            <th>Statut</th>
            {/* <th>Vedette</th> */}
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {productSales.map((productSale) => (
            <tr key={productSale.id}>
              <td>
                {productSale.images && productSale.images[0] ? (
                  <img 
                    src={`${API_BASE_URL}${productSale.images[0].url}`}
                    alt={productSale.title}
                    style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                    className="rounded"
                  />
                ) : (
                  <div 
                    className="bg-secondary d-flex align-items-center justify-content-center rounded"
                    style={{ width: '50px', height: '50px' }}
                  >
                    <i className="fas fa-image text-white"></i>
                  </div>
                )}
              </td>
              <td>
                <div>
                  <strong>{productSale.title}</strong>
                  {productSale.brand && (
                    <div className="text-muted small">{productSale.brand}</div>
                  )}
                </div>
              </td>
              <td>
                <span className="font-monospace small">
                  {productSale.ean_code || '-'}
                </span>
              </td>
              <td>{formatPrice(productSale.unit_price)}</td>
              <td>
                {productSale.bulk_price ? (
                  <div>
                    <small className="text-muted">{productSale.bulk_quantity || 2}x</small><br/>
                    <span>{formatPrice(productSale.bulk_price)}</span>
                  </div>
                ) : (
                  '-'
                )}
              </td>
              <td>
                <span className={`badge ${productSale.stock_quantity > 0 ? 'bg-success' : 'bg-warning'}`}>
                  {productSale.stock_quantity}
                </span>
              </td>
              <td>
                <span className="badge bg-info">
                  {getCategoryLabel(productSale)}
                </span>
              </td>
              {/* <td>{productSale.brand || '-'}</td> */}
              <td>
                <span className={`badge bg-${productSale.is_active ? 'success' : 'danger'}`}>
                  {productSale.is_active ? 'Actif' : 'Inactif'}
                </span>
              </td>
              {/* <td>
                {productSale.featured && (
                  <span className="badge bg-warning text-dark">
                    <i className="fas fa-star"></i> Vedette
                  </span>
                )}
              </td> */}
              <td>
                <div className="btn-group">
                  <button
                    className="btn btn-sm btn-info me-2"
                    onClick={() => onEdit(productSale)}
                    data-bs-toggle="modal"
                    data-bs-target="#editProductSaleModal"
                    title="Modifier"
                  >
                    Modifier
                  </button>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => onDelete(productSale.documentId)}
                    title="Supprimer"
                  >
                    Supp
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductSalesTable;